export enum InterestIntervalEnum
{
    "last_month"="LastMonth",
    "last_seven" = "LastSeven",
    "this_month" = "ThisMonth",
    "user_defined" = "UserDefined",
    "recent_missing_data" = "RecentMissingData",
    "ytd_missing_data" =  "YearToDateMissing" 
}